// PreviewTemplates.js
import React from "react";
import { expandTemplate } from "./expandTemplate";
import templateQuestions from "./templateQuestions";
import Latex from "react-latex-next";
import "katex/dist/katex.min.css";

function PreviewTemplates() {
  return (
    <div style={styles.wrapper}>
      <h1>🔍 Template Question Preview</h1>

      {templateQuestions.map((template, index) => {
        const generated = expandTemplate(template, 30); // Generate 10 questions

        return (
          <div key={index} style={styles.templateBlock}>
            <h2>
              {template.topic} —{" "}
              <span style={styles.sub}>{template.subject}</span>
            </h2>

            {generated.map((q, i) => (
              <div key={i} style={styles.questionCard}>
                <div style={styles.subtopic}>
                  📌 {q.subtopic || "No Subtopic"}
                </div>

                {q.textLines ? (
                  q.textLines.map((line, j) => (
                    <div key={j} style={styles.latex}>
                      <Latex>{line}</Latex>
                    </div>
                  ))
                ) : (
                  <p>⚠️ Failed to generate question.</p>
                )}

                <p style={styles.answer}>✅ Answer: {q.answer}</p>
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  wrapper: {
    padding: "2rem",
    maxWidth: "900px",
    margin: "auto",
    fontFamily: "Poppins, sans-serif",
    background: "#f0f8ff",
  },
  templateBlock: {
    marginBottom: "2rem",
    padding: "1rem",
    border: "1px solid #ddd",
    borderRadius: "10px",
    backgroundColor: "#fff",
  },
  questionCard: {
    background: "#f9f9f9",
    padding: "1rem",
    marginBottom: "1rem",
    borderRadius: "8px",
    borderLeft: "5px solid #6cb4ff",
  },
  subtopic: {
    fontSize: "1rem",
    fontWeight: "600",
    marginBottom: "0.5rem",
    color: "#555",
  },
  latex: {
    fontSize: "1.2rem",
    marginBottom: "0.5rem",
  },
  answer: {
    color: "#2e7d32",
    fontWeight: "600",
  },
  sub: {
    fontSize: "1rem",
    fontWeight: "normal",
    color: "#555",
  },
};

export default PreviewTemplates;
